// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Raleway, sans-serif;
}

ion-footer {
  background-color: #262626;
  color: white;
  text-align: center;
  padding: 2px 0;
  align-items: center;
  /* Vertically center content */
  justify-content: center;
  /* Horizontally center content */
}

.container {
  width: 100%;
  margin: 0 auto;
  --background: #262626;
  color: white;
}

.img {
  width: 73px;
}

h1 {
  font-family: "Raleway", sans-serif;
  font-size: 60px;
  /* Additional styles if needed */
}

/* Adjust styles for smaller screens */
@media (max-width: 768px) {
  ion-footer {
    font-size: 18px;
  }
  h1 {
    font-size: 48px;
    /* Adjust font size for smaller screens */
  }
}
@media (max-height: 768px) {
  .img {
    width: 62px;
  }
}
@media (max-width: 480px) {
  ion-footer {
    font-size: 16px;
  }
  h1 {
    font-size: 32px;
    /* Further adjust font size for mobile screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.page.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEE;EACE,gCAAA;AACJ;;AAEE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;EAIA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;AAHJ;;AAME;EACE,WAAA;EAEA,cAAA;EAGA,qBAAA;EACA,YAAA;AANJ;;AASE;EACE,WAAA;AANJ;;AASE;EACE,kCAAA;EACA,eAAA;EACA,gCAAA;AANJ;;AASE,sCAAA;AACA;EAEE;IACE,eAAA;EAPJ;EAUE;IACE,eAAA;IACA,yCAAA;EARJ;AACF;AAWE;EACE;IACE,WAAA;EATJ;AACF;AAYE;EAEE;IACE,eAAA;EAXJ;EAcE;IACE,eAAA;IACA,gDAAA;EAZJ;AACF","sourcesContent":["* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n  \n  body {\n    font-family: Raleway, sans-serif;\n  }\n  \n  ion-footer {\n    background-color: #262626;\n    color: white;\n    text-align: center;\n    //padding: 20px 0;\n    padding: 2px 0;\n    //height: 160px;\n    //height: 110px;\n    //display: flex;\n    align-items: center;\n    /* Vertically center content */\n    justify-content: center;\n    /* Horizontally center content */\n  }\n  \n  .container {\n    width: 100%;\n    //max-width: 1200px;\n    margin: 0 auto;\n    //padding: 20px;\n    //padding: 2px;\n    --background: #262626;\n    color: white;\n  }\n  \n  .img{\n    width: 73px;\n  }\n  \n  h1 {\n    font-family: 'Raleway', sans-serif;\n    font-size: 60px;\n    /* Additional styles if needed */\n  }\n  \n  /* Adjust styles for smaller screens */\n  @media (max-width: 768px) {\n  \n    ion-footer {\n      font-size: 18px;\n    }\n  \n    h1 {\n      font-size: 48px;\n      /* Adjust font size for smaller screens */\n    }\n  }\n\n  @media (max-height: 768px) {\n    .img{\n      width: 62px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n  \n    ion-footer {\n      font-size: 16px;\n    }\n  \n    h1 {\n      font-size: 32px;\n      /* Further adjust font size for mobile screens */\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
